import { COMPETENCIA_INICIAL, currentCompetencia, formatBRL, nextCompetencia } from '@agencia/shared';

export const TIMEZONE = 'America/Bahia';
export { formatBRL };

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

/** "2026-11" -> "novembro de 2026" */
export function formatCompetencia(c: string): string {
  const [y, m] = c.split('-');
  return `${MESES[Number(m) - 1] ?? m} de ${y}`;
}

/** "2026-11" -> "novembro" */
export function nomeMes(c: string): string {
  return MESES[Number(c.split('-')[1]) - 1] ?? c;
}

/** "2026-11-17" -> "17/11/2026" */
export function formatDate(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

/** "2026-11-17" -> "17/11" */
export function formatDayMonth(iso: string): string {
  const [, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}`;
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: TIMEZONE }).format(new Date(iso));
}

/** Fração exata "0.876500" -> "87,65%" */
export function formatPct(fraction: string | number): string {
  const n = Number(fraction) * 100;
  return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(Math.floor(n * 100 + 1e-9) / 100)}%`;
}

/** "há 3 minutos" */
export function tempoDesde(iso: string | null): string {
  if (!iso) return 'ainda não sincronizado';
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return 'agora há pouco';
  const m = Math.round(s / 60);
  if (m < 60) return `há ${m} minuto${m > 1 ? 's' : ''}`;
  const h = Math.round(m / 60);
  return `há ${h} hora${h > 1 ? 's' : ''}`;
}

/**
 * Valor digitado pelo usuário -> "1234.56".
 * Aceita "1.234,56", "1234,56", "1234.56", "R$ 1.234". Retorna null se inválido.
 */
export function parseMoneyInput(raw: string): string | null {
  let s = raw.replace(/[R$\s]/g, '');
  if (!s) return null;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(s)) return null;
  const [i = '0', d = ''] = s.split('.');
  return `${Number(i)}.${d.padEnd(2, '0')}`;
}

/** "1234.5" -> "1.234,50" (para preencher campos de edição). */
export function toInputMoney(v: string): string {
  const [i = '0', d = '00'] = v.split('.');
  return `${Number(i).toLocaleString('pt-BR')},${d.padEnd(2, '0')}`;
}

/** Meses disponíveis no seletor: do início da operação até o atual (mais recente primeiro). */
export function mesesDisponiveis(): string[] {
  const atual = currentCompetencia(new Date(), TIMEZONE);
  const out: string[] = [];
  for (let c = COMPETENCIA_INICIAL; c <= atual; c = nextCompetencia(c)) out.push(c);
  return out.reverse();
}

export const FAIXA_LABEL: Record<string, string> = {
  ABAIXO_DO_PISO: 'Abaixo do piso',
  PROPORCIONAL: 'Proporcional',
  ACELERADOR: 'Acima da meta',
};
